var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-table',{attrs:{"store-name":"adminorganizationusers","headers":_vm.headers,"query-filter":_vm.queryFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }